import { Logger } from '@sitecore-search/common';
import { OCRequest as OCSearchRequest, Request as SearchRequest, getServiceConfig } from '@sitecore-search/data';
import OCController from '../controller/orderCloudController.js';
/**
 * @desc: Decorator function that attach properties needed depending on the case.
 * Ordercloud needs to send an extended request so that is grabbed form OCController
 * and decorates the request to be send.
 * Otherwise in the case of the search, there is no need.
 */
const createRequest = () => {
    const { connector } = getServiceConfig();
    switch (connector) {
        case 'oc': {
            Logger.info('Using OC Request');
            const request = new OCSearchRequest();
            request.setOrderCloudContext(OCController.getContext().toJson());
            return request;
        }
        default:
            Logger.info('Using default Request');
            return new SearchRequest();
    }
};
export default createRequest;
